const styles = (theme) => ({
  dateRange: {
    fontSize: '1.0625rem',
    fontWeight: 500,
    paddingBottom: theme.spacing.unit * 2,
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      fontSize: '1.1875rem',
      textAlign: 'left',
    },
  },
  downloadContainer: {
    textAlign: 'center',
    paddingBottom: theme.spacing.unit * 3,
    fontSize: '1.125rem',
    [theme.breakpoints.up('md')]: {
      textAlign: 'right',
      paddingBottom: 0,
    },
  },
  tableCard: {
    boxShadow: 'none',
    border: 'none',
  },
  tableCardContent: {
    paddingLeft: 0,
    paddingRight: 0,
    '&&': {
      paddingBottom: 0,
    },
  },
  tableCellHead: {
    paddingLeft: 0,
    fontFamily: 'Calibre',
    fontSize: '1.125rem',
  },
  tableCell: {
    paddingLeft: 0,
    fontFamily: 'Calibre',
    fontSize: '1.125rem',
  },
  credit: {
    color: '#438509',
    [theme.breakpoints.up('sm')]: {
      fontWeight: 500,
      fontSize: '1.125rem',
    },
  },
  creditMobile: {
    color: '#438509',
  },
  gridRow: {
    borderBottom: `1px solid ${theme.palette.border.light}`,
  },
  gridItem: {
    margin: `${theme.spacing.unit}px 0`,
  },
  description: {
    fontSize: '0.875rem',
  },
  date: {
    fontSize: '0.8125rem',
    color: theme.palette.text.grey,
  },
  amount: {
    fontSize: '0.875rem',
    fontWeight: 500,
    textAlign: 'right',
  },
  runningBalanceMobile: {
    fontSize: '0.8125rem',
    color: theme.palette.text.grey,
    textAlign: 'right',
  },
  helpText: {
    marginTop: theme.spacing.unit * 3,
  },
  currentBalance: {
    borderTop: `1px solid ${theme.palette.border.dark}`,
    borderBottom: `1px solid ${theme.palette.border.grey}`,
    '& + &': {
      borderTop: 'none',
    },
  },
  currentBalanceLabel: {
    fontWeight: 500,
  },
  transactionsTableBody: {
    '& tr:last-child td, & tr:first-child td, & tr:nth-last-child(2) td': {
      borderColor: theme.palette.border.dark,
    },
  },
  nestedGridItem: {
    width: '100%',
    textAlign: 'right',
  },
});

export default styles;
